import { hasStyleOption } from './clean-department-utils'
import _ from 'lodash'

export function cleanEntityPricing (entity, department, menuBlob, forPublish = false) {
  if (!_.has(entity, 'pricing')) return

  const availableSchemes = _.get(menuBlob, 'pricingSchemes', [])
    .filter(scheme => scheme.isActive !== false || !forPublish || scheme.$added)
    .map(next => next.id)

  entity.pricing = entity.pricing.filter(({ pricingScheme }) => availableSchemes.includes(pricingScheme))

  for (const scheme of entity.pricing) {
    cleanScheme(scheme, department)
  }
}

function cleanScheme (scheme, department) {
  cleanItemBased(scheme, department)
  cleanToppingBased(scheme, department)
  cleanStyleUpcharge(scheme, department)
}

function cleanItemBased (scheme, department) {
  if (!_.has(scheme, 'itemBased')) return

  scheme.itemBased = scheme.itemBased
    .filter(next => next.flatRate || hasStyleOption(next.size, next.sizeOption, department))
}

function cleanToppingBased (scheme, department) {
  if (!_.has(scheme, 'toppingBased.toppingsPrice')) return

  scheme.toppingBased.toppingsPrice = scheme.toppingBased.toppingsPrice
    .filter(next => next.flatRate || hasStyleOption(next.size, next.sizeOption, department))
}

function cleanStyleUpcharge (scheme, department) {
  if (!_.has(scheme, 'styleUpcharge')) return

  scheme.styleUpcharge = scheme.styleUpcharge
    .filter(next =>
      (next.flatRate || hasStyleOption(next.size, next.sizeOption, department)) &&
      hasStyleOption(next.style, next.styleOption, department)
    )
}
